<template>
  <div class="main_index">
    <div class="main_content">
      <div class="search_div">
        <div class="searchbox">
          <input
            type="text"
            class="searchInput"
            placeholder="姓名/电话/条形码/医院/检验项目"
            v-model="queryContent"
          />
          <button @click="searchBtn" class="searchBtn">搜索</button>
        </div>
        <div class="searchCondition">
          <div class="searchTime">
            <span>送检时间：</span>
            <input
              placeholder="请选择时间"
              type="date"
              class="date data1"
              :value="startDate"
              v-model="startDate"
            />
            <div class="line"></div>
            <input
              placeholder="请选择时间"
              type="date"
              class="date"
              v-model="endDate"
            />
          </div>
          <div class="searchStatus">
            <span>结果状态：</span>
            <div class="overStatus overStatus01">全部</div>
            <div class="moreSearch" @click="showHeightBtn">
              <img src="@assets/images/new/gjss@2x.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="nodata" v-if="datalist.length <= 0">
        <div class="nodata_zhanwei">
          <img src="@assets/images/new/empty.png" />
          <p>没有找到匹配记录</p>
        </div>
      </div>
      <div class="hasData" v-if="datalist.length > 0">
        <div class="zhanwei2" style="height: 3.2rem;"></div>
        <div class="hasData_content">
          <div
            class="li"
            :data-orderId="item.barcode"
            v-for="(item, index) in datalist"
          >
            <p class="ptext" @click="showOneMore(item)">
              {{ item.patientName }}-{{ item.requestItemMixname }}
            </p>
            <span
              class="limore"
              @click="showOneMore(item)"
              :data-thisorderinfo="item"
              ><img src="@assets/images/new/more@2x.png"
            /></span>
            <img
              v-if="item.scimg == 1"
              src="@assets/images/new/wdy@2x.png"
              class="shoucang1"
              @click="shoucangData(item, index)"
            />
            <img
              v-if="item.scimg == 2"
              src="@assets/images/new/ydy@2x.png"
              class="shoucang1"
              @click="shoucangData(item, index)"
            />
          </div>
        </div>

        <div class="overdata">我是有底线的~</div>
        <div style="height: 1.4rem;"></div>
      </div>
    </div>
    <!-- 高级筛选-开始 -->
    <div class="search_height" v-if="searchHeightContent">
      <div class="heightContent">
        <div class="heightContent_mode1">
          <p class="songtime">送检时间</p>
          <div class="time2">
            <input
              placeholder="请选择开始时间"
              type="date"
              class="date2"
              :value="startDate"
              v-model="startDate"
            />
            <div class="line2"></div>
            <input
              placeholder="请选择结束时间"
              type="date"
              class="date2"
              v-model="endDate"
            />
          </div>
          <div class="height_div">
            <span>姓名：</span
            ><input
              placeholder="请输入查询姓名"
              v-model="patientName"
              class="input_search2"
            />
          </div>
          <div class="height_div">
            <span>手机号码：</span
            ><input
              placeholder="请输入手机号码"
              v-model="phoneNumber"
              class="input_search2"
            />
          </div>
          <div class="height_div">
            <span>条形码：</span
            ><input
              placeholder="请输入条形码"
              v-model="barcode"
              class="input_search2"
            />
          </div>
          <div class="height_div">
            <span>检测项目：</span
            ><input
              placeholder="请输入检测项目"
              v-model="requestItemMixname"
              class="input_search2"
            />
          </div>
          <div class="height_div">
            <span>送检医生：</span
            ><input
              placeholder="请输入送检医生"
              v-model="requestDoctorName"
              class="input_search2"
            />
          </div>
          <div class="height_div">
            <span>送检医院：</span
            ><input
              placeholder="请输入送检医院"
              v-model="sendoutOrganizationName"
              class="input_search2"
            />
          </div>
          <div style="height: 1.4rem;"></div>
        </div>

        <div class="heightContent_btns">
          <div class="clearData" @click="clearData">清空搜索条件</div>
          <div class="yesSearch" @click="searchHeight">确定</div>
        </div>
      </div>
      <span class="closeSearch" @click="closeSearchHeight"
        ><img src="@assets/images/new/quxiao@2x.png"
      /></span>
    </div>
    <!-- 高级筛选-结束 -->
    <!-- 检测详情-开始 -->
    <div class="dataInfo" v-if="dataInfo">
      <div class="dataInfo_content" v-for="(item, i) in baogaoInfo">
        <div class="dataInfo_contentTitle">
          <p class="p1">检测详情</p>
          <p class="p2">(最终结果以报告单为准)</p>
          <p class="pTime">
            报告咨询电话(工作日8:30-12:00，13:00-16:30)：<a
              :href="'tel:' + '028-68783996'"
              >028-68783996</a
            >；<a :href="'tel:' + '19136329463'">19136329463</a>
          </p>
          <span class="close_datainfo" @click="close_datainfo"
            ><img src="@assets/images/new/colse@2x.png"
          /></span>
        </div>
        <div class="info_div">
          <span>支付状态：</span>
          <label v-if="item.feeStatus == '1'">已缴费</label>
          <label v-if="item.feeStatus == '0'" @click="showPay"
            >未缴费-去支付></label
          >
        </div>
        <div class="info_div">
          <span>订单金额：</span>
          <label>{{ item.orderFee }}</label>
        </div>
        <div class="info_div">
          <span>报告状态：</span>
          <label v-if="item.testStatus == 0">未采集</label>
          <label v-if="item.testStatus == 10">打印</label>
          <label v-if="item.testStatus == 20">采集</label>
          <label v-if="item.testStatus == 30">打包</label>
          <label v-if="item.testStatus == 40">送检</label>
          <label v-if="item.testStatus == 50">接受</label>
          <label v-if="item.testStatus == 60">登记</label>
          <label v-if="item.testStatus == 65">取消审核</label>
          <label v-if="item.testStatus == 70">已审核</label>
          <label v-if="item.testStatus == 80">报告打印</label>
          <label v-if="item.testStatus == -10">退单</label>
          <label v-if="item.testStatus == -20">撤销</label>
        </div>
        <div class="info_div">
          <span>姓名：</span>
          <label>{{ item.patientName }}</label>
        </div>
        <div class="info_div">
          <span>电话：</span>
          <label>{{ item.phoneNumber }}</label>
        </div>
        <div class="info_div">
          <span>条形码：</span>
          <label>{{ item.barcode }}</label>
        </div>
        <div class="info_div">
          <span>医院：</span>
          <label>{{ item.sendoutOrganizationName }}</label>
        </div>
        <div class="info_div">
          <span>检测项目：</span>
          <label>{{ item.requestItemMixname }}</label>
        </div>
        <div class="info_div">
          <span>开单时间：</span>
          <label>{{ item.requestDoctDate }}</label>
        </div>
        <div style="height: 1.24rem;"></div>
        <div class="btnss_2">
          <!-- <div class="btn1">申请单</div> -->
          <!-- <div class="btn2" @click="downloadPDF(item.filePath)"> -->
          <div
            v-if="item.filePath"
            class="btn2"
            id="baodan"
            @click="downloadPDFUrl(item.filePath, 'baodan.pdf')"
          >
            报告单(PDF)
          </div>
          <div v-else class="btn1">
            未出<label v-if="item.testStatus != 0"
              >({{ item.reportDate }})</label
            >
          </div>
          <!-- div v-else class="btn1">未出({{ item.reportDate }})</div> -->
        </div>
        <div class="pdf" v-if="pdfImg">
          <pdf ref="pdf" :src="item.filePath"> </pdf>
        </div>
        <div>
          <PDF ref="pdf"></PDF>
          <!-- <Button type="primary" size="small" @click="previewWeekly(item.id)">预览</Button>
		    	<Button type="primary" size="small" @click="downloadWeekly(item.id,item.name)">下载</Button> -->
        </div>
        <!-- 去支付-显示二维码 -->
        <div class="mengceng_addmore dialog_pay" v-if="pay_dialog">
          <div class="pay_ewm">
            <img :src="item.qrcodeUrl" />
            <p>识别扫描二维码支付订单</p>
            <span @click="iKnowBtn">我知道了</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载蒙层 -->
    <!-- <div class="mengceng_addmore2" v-if="addmoreDataC">
      <img src="@assets/images/loading.gif" />
      <p>读取更多数据...</p>
    </div> -->
    <div class="mengceng_addmore" v-if="addmoreDataC">
      <div class="mengceng_addmore2">
        <img src="@assets/images/loading.gif" />
        <p>读取更多数据...</p>
      </div>
    </div>
    <!-- 检测详情-结束 -->
    <footer class="hc_footer">
      <div class="footerDiv">
        <router-link :to="'/user/hc_main'" class="btna2">
          <div class="my_info_div activefooter">
            <img src="@assets/images/new/baogao@2x.png" /><span>报告</span>
          </div>
        </router-link>
      </div>
      <div class="footerDiv">
        <router-link :to="'/user/hc_my'" class="btna2">
          <div class="my_info_div">
            <img src="@assets/images/new/wl@2x.png" /><span>我的</span>
          </div>
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  hcAutomaticInspection,
  hcAccurateInspection,
  hcCollectionReport,
  hcUnCollectionReport
} from "@api/user";
import axios from "axios";
import cookie from "@utils/store/cookie";
export default {
  name: "usermainIndex",
  data: function() {
    return {
      pay_dialog: false,
      addmoreDataC: false,
      queryContent: "",
      barcode: "",
      patientName: "",
      phoneNumber: "",
      sendoutOrganizationName: "",
      requestDoctorName: "",
      requestItemMixname: "",
      startDate: "",
      endDate: "",
      testStatus: "",
      feeStatus: "",
      searchHeightContent: false,
      order_status: false,
      order_pdf: false,
      dataInfo: false,
      datalist: [],
      baogaoInfo: [],
      pdfImg: false,
      page1: 0, //正常搜索
      page2: 0, //高级搜索
      searchData: "", //正常搜索参数
      searchHeightData: "", //正常搜索参数
      chooseType: 1, //默认未正常搜索，2为高级搜索
      isScroll: false,
      loadingMore: false,
      showDialog_: true //默认可以执行
    };
  },
  mounted: function() {
    this.init();
    document.addEventListener("scroll", this.scrollMoreData, false);
  },
  methods: {
    init: function() {
      console.log("expires_time:", cookie.get("expires_time"));
      console.log("token:", cookie.get("token"));
      var that = this;
      var nowdate = new Date(),
        month;
      var day = nowdate.getDate();
      console.log("month:", Number(nowdate.getMonth()) + 1);

      if (Number(nowdate.getMonth() + 1) < 10) {
        month = "0" + (Number(nowdate.getMonth()) + 1);
      } else {
        month = Number(nowdate.getMonth()) + 1;
      }
      if (Number(day) < 10) {
        day = "0" + Number(day);
      }
      var datew = nowdate.getFullYear() + "-" + month + "-" + day;
      datew = datew.toString();
      // that.startDate = datew;
      console.log("结束时间endDate：", datew);
      that.startDate = that.getData(-45);
      console.log("开始时间：", that.startDate);
      that.endDate = datew;
      // that.searchBtn();
    },
    getData(day) {
      var today = new Date();
      console.log("today:", today);
      console.log("today.getTime():", today.getTime());
      var targetday = today.getTime() + 1000 * 60 * 60 * 24 * day;
      console.log("targetday:", targetday);
      today.setTime(targetday);
      console.log("today:", today);
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandMonth(tMonth + 1);
      tDate = this.doHandMonth(tDate);
      console.log("tMonth:", tMonth);
      console.log("tDate:", tDate);
      // if (Number(tDate) < 10) {
      //   tDate = "0" + tDate;
      // }
      let newtime = (tYear + "-" + tMonth + "-" + tDate).replace(/-/g, "/");
      console.log("newtime:", newtime);
      console.log("return:", tYear + "-" + tMonth + "-" + tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      console.log("m:", m);
      return m;
    },
    searchBtn: function() {
      var that = this;
      that.chooseType = 1; //正常搜索
      that.page1 = 0; //恢复初始值
      that.datalist = []; //恢复初始值
      that.addmoreDataC = false;
      that.searchFunction();
    },
    //正常搜索-列表
    searchFunction() {
      var that = this;
      that.addmoreDataC = true;
      console.log("that.addmoreDataC:", that.addmoreDataC);
      // var data = {
      //   queryContent: that.queryContent,
      //   startDate: that.startDate,
      //   endDate: that.endDate,
      //   page: that.page1 + 1,
      //   limit: 10
      // };
      if (that.queryContent == "") {
        that.addmoreDataC = false;
        return that.$dialog.toast({ mes: "搜索内容不能为空" });
      }
      let param = new FormData(); // 创建form对象
      param.append("queryContent", that.queryContent); // 通过append向form对象添加数据
      param.append("startDate", that.startDate); // 通过append向form对象添加数据
      param.append("endDate", that.endDate); // 通过append向form对象添加数据
      param.append("page", that.page1 + 1); // 通过append向form对象添加数据
      param.append("limit", 30); // 通过append向form对象添加数据
      that.searchData = param;
      that.page1 = that.page1 + 1;
      hcAutomaticInspection(that.searchData)
        .then(res => {
          console.log("then_res:", res);
        })
        .catch(e => {
          console.log("e.code:", e.code);
          console.log("e.data.code:", e.data.code);
          if (e.data.code == 200) {
            for (var i2 = 0; i2 < e.data.data.list1.length; i2++) {
              if (
                e.data.data.brcode.indexOf(e.data.data.list1[i2].barcode) == -1
              ) {
                e.data.data.list1[i2].scimg = 1;
              } else {
                e.data.data.list1[i2].scimg = 2;
              }
            }
            that.datalist = that.datalist.concat(e.data.data.list1);
            that.isScroll = true;
            that.loadingMore = false;
            that.addmoreDataC = false;
          } else {
            that.datalist = [];
            that.addmoreDataC = false;
          }
        });
    },
    showHeightBtn: function() {
      this.searchHeightContent = true;
    },
    closeSearchHeight: function() {
      this.searchHeightContent = false;
    },
    clearData: function() {
      this.barcode = "";
      this.patientName = "";
      this.phoneNumber = "";
      this.sendoutOrganizationName = "";
      this.requestDoctorName = "";
      this.requestItemMixname = "";
    },
    searchHeight: function() {
      var that = this;
      that.chooseType = 2; //高级搜索
      that.page2 = 0; //恢复初始值
      that.datalist = []; //恢复初始值
      that.searchHeightFunction();
    },
    searchHeightFunction() {
      var that = this;
      that.addmoreDataC = true;
      console.log("that.addmoreDataC:", that.addmoreDataC);
      // var data = {
      //   patientName: that.patientName,
      //   phoneNumber: that.phoneNumber,
      //   barcode: that.barcode,
      //   requestDoctorName: that.requestDoctorName,
      //   requestItemMixname: that.requestItemMixname,
      //   startDate: that.startDate,
      //   endDate: that.endDate,
      //   feeStatus: that.feeStatus,
      //   testStatus: that.testStatus,
      //   page: that.page2 + 1,
      //   limit: 10
      // };
      let param = new FormData(); // 创建form对象
      param.append("patientName", that.patientName); // 通过append向form对象添加数据
      param.append("phoneNumber", that.phoneNumber); // 通过append向form对象添加数据
      param.append("barcode", that.barcode); // 通过append向form对象添加数据
      param.append("requestDoctorName", that.requestDoctorName); // 通过append向form对象添加数据
      param.append("requestItemMixname", that.requestItemMixname); // 通过append向form对象添加数据
      param.append("startDate", that.startDate); // 通过append向form对象添加数据
      param.append("endDate", that.endDate); // 通过append向form对象添加数据
      param.append("feeStatus", that.feeStatus); // 通过append向form对象添加数据
      param.append("testStatus", that.testStatus); // 通过append向form对象添加数据
      param.append("page", that.page2 + 1); // 通过append向form对象添加数据
      param.append("limit", 30); // 通过append向form对象添加数据
      that.page2 = that.page2 + 1;
      that.searchHeightData = param;
      hcAccurateInspection(that.searchHeightData)
        .then(res => {})
        .catch(e => {
          if (e.data.code == 200) {
            for (var i2 = 0; i2 < e.data.data.list1.length; i2++) {
              if (
                e.data.data.brcode.indexOf(e.data.data.list1[i2].barcode) == -1
              ) {
                e.data.data.list1[i2].scimg = 1;
              } else {
                e.data.data.list1[i2].scimg = 2;
              }
            }
            that.datalist = that.datalist.concat(e.data.data.list1);
            that.isScroll = true;
            that.loadingMore = false;
            that.addmoreDataC = false;
          } else {
            that.datalist = [];
            that.addmoreDataC = false;
          }
          that.searchHeightContent = false;
          that.addmoreDataC = false;
        });
    },
    showOneMore: function(e) {
      this.dataInfo = true;
      this.baogaoInfo.push(e);
      this.showDialog_ = false;
    },
    close_datainfo() {
      this.dataInfo = false;
      this.showDialog_ = true;
      this.baogaoInfo = [];
    },
    shoucangData(e, num) {
      var that = this;
      if (e.scimg == 1) {
        hcCollectionReport({ report_id: e.barcode })
          .then(res => {})
          .catch(data => {
            if (data.msg == "收藏成功!") {
              e.scimg == 2;
              that.datalist[num].scimg = 2;
              that.$dialog.toast({ mes: data.msg });
            }
          });
      } else {
        hcUnCollectionReport({
          report_id: e.barcode
        })
          .then(res => {})
          .catch(data => {
            if (data.msg == "取消收藏成功!") {
              e.scimg == 1;
              that.datalist[num].scimg = 1;
              that.$dialog.toast({ mes: data.msg });
            }
          });
      }
    },
    downloadPDFUrl(url, fileName) {
      var that = this;
      // url = "https://huachuang.congwa.xyz/uploads/144-144.pdf";
      if (url == "") {
        that.$dialog.toast({ mes: "报告单目前还未出来！请耐心等待" });
        return;
      } else {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          console.log("安卓");
          window.open(url);
        } else {
          console.log("ios");
          // hcDownloadPath(url).then(res => {
          //   console.log("下载pdf:", res);
          // });
          // window.location.href =
          //   "https://huachuang.congwa.xyz/api/download_path?file_name=" + url;
          window.location.href = url;
          // axios({
          //   url: url,
          //   // responseType: "arraybuffer",
          //   responseType: "blob",
          //   method: "GET"
          // }).then(res => {
          //   console.log("res:", res);
          //   that.fileDownload(res.data, fileName, url);
          // });
        }
      }
    },
    fileDownload: function(data, fileName, url) {
      var that = this;
      let blob = new Blob([data], {
        //type类型后端返回来的数据中会有，根据自己实际进行修改
        type: "application/octet-stream"
      });
      console.log("blob:", blob);
      let filename = fileName;
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var blobURL = window.URL.createObjectURL(blob);
        console.log("blob:", blob);
        // 创建隐藏<a>标签进行下载
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        // tempLink.href = url;
        tempLink.setAttribute("download", filename);
        // if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
        // }
        console.log("blobURL:", blobURL);
        console.log("tempLink:", tempLink);
        document.body.appendChild(tempLink);
        tempLink.click();
        setTimeout(function() {
          that.$dialog.toast({ mes: "移除" });
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }, 3000);
      }
    },
    scrollMoreData() {
      var that = this;
      const scrollTopHeight =
        document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
      const clientHeight =
        document.documentElement.clientHeight || window.body.clientHeight; //屏幕可用工作区高度
      const offsetHeight =
        document.documentElement.offsetHeight || document.body.offsetHeight; //网页可见区域高(包括边线的宽)
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      console.log(
        "scrollTopHeight + clientHeight + 20:",
        scrollTopHeight + clientHeight + 50
      );
      console.log("scrollHeight:", scrollHeight);
      if (
        scrollTopHeight + clientHeight + 50 >= scrollHeight &&
        this.isScroll
      ) {
        if (that.showDialog_) {
          that.isScroll = false;
          that.loadingMore = true;
          that.addmoreDataC = true;
          if (that.chooseType == 1) {
            //正常搜索
            that.searchFunction();
          } else if (that.chooseType == 2) {
            //高级搜索
            that.searchHeightFunction();
          }
        }
      }
    },
    iKnowBtn() {
      this.pay_dialog = false;
    },
    showPay() {
      this.pay_dialog = true;
    }
  },
  destroyed() {
    document.removeEventListener("scroll", this.scrollMoreData, false);
  }
};
</script>

<style>
body {
  background-color: #f2f3f8 !important;
}
.mengceng_addmore {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  z-index: 99;
  padding: 0.2rem 0;
  width: 3rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 0.4rem; */
}
.dialog_pay {
  background-color: rgba(0, 0, 0, 0.7);
}
.pay_ewm {
  position: absolute;
  width: 5rem;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 0.2rem;
  color: #333;
  font-size: 0.24rem;
  padding: 0.4rem;
}
.pay_ewm img {
  display: block;
  width: 3rem;
  margin: 0 auto;
}
.pay_ewm p {
  text-align: center;
  margin: 0.2rem auto 0;
}
.pay_ewm span {
  display: block;
  width: 3rem;
  line-height: 0.7rem;
  text-align: center;
  border: 0.02rem solid #999;
  font-size: 0.28rem;
  border-radius: 0.16rem;
  margin: 0.4rem auto 0;
}
.mengceng_addmore2 {
  /* width: 100%; */
  width: 3rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  margin: 0.2rem;
  /* display: -webkit-box; */
  /* display: -ms-flexbox; */
  /* display: flex; */
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.2rem 0;
}
.mengceng_addmore2 img {
  display: block;
  width: 0.6rem;
  margin: 0 auto 0.15rem;
}
.mengceng_addmore2 p {
  font-size: 0.24rem;
  /* margin-left: 0.2rem; */
}
.main_index {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f2f3f8;
}

.main_content {
  width: 100%;
  margin: 0 auto;
}

.search_div {
  width: 100%;
  height: 3.2rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.searchbox {
  width: 100%;
  background-color: #f2f3f8;
  display: flex;
  padding: 0.22rem 0.24rem;
}

.searchInput {
  display: block;
  width: 6.02rem;
  height: 0.7rem;
  border-radius: 0.35rem;
  background-color: #fff;
  font-size: 0.28rem;
  color: #333;
  padding-left: 0.6rem;
  background-image: url(../../assets/images/new/ss@2x.png);
  background-position: 0.16rem center;
  background-repeat: no-repeat;
  background-size: 0.28rem 0.28rem;
}

.searchInput::-webkit-input-placeholder {
  color: #a1a9b5;
  font-size: 0.28rem;
}

.searchBtn {
  display: block;
  width: calc(100% - 6.02rem);
  color: #275caa;
  font-size: 0.3rem;
  text-align: center;
  height: 0.7rem;
  line-height: 0.7rem;
}

.searchCondition {
  width: 100%;
  background-color: #fff;
  position: relative;
  padding: 0.3rem 0.24rem;
}

.searchTime,
.searchStatus {
  width: 100%;
  display: flex;
  position: relative;
}

.searchTime span,
.searchStatus span {
  display: block;
  width: 1.3rem;
  color: #3c485b;
  font-size: 0.24rem;
  height: 0.58rem;
  line-height: 0.58rem;
}

.searchTime input,
.searchStatus .overStatus {
  display: block;
  width: 2.6rem;
  color: #3c485b;
  font-size: 0.24rem;
  background-color: #f2f3f8;
  height: 0.58rem;
  border-radius: 0.3rem;
  padding: 0 0.2rem;
  line-height: 0.58rem;
  position: relative;
}
.overStatus01 {
  background-color: transparent !important;
}
.line {
  display: block;
  height: 0.03rem;
  width: 0.25rem;
  margin: 0.26rem 0.15rem;
  background-color: #e2e2e2;
}

.searchTime input::-webkit-input-placeholder {
  color: #3c485b;
  font-size: 0.24rem;
}

.data1 {
  /* margin-right: 0.3rem; */
}

.searchStatus .moreSearch {
  position: absolute;
  right: 0.2rem;
  width: 1.8rem;
  top: 0;
}

.searchStatus .moreSearch img {
  display: block;
  width: 100%;
}

.searchStatus {
  margin-top: 0.32rem;
}

.overStatus {
  line-height: 0.58rem;
  text-indent: 0.1rem;
}

.nodata {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #f2f3f8;
}

.nodata_zhanwei {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
}

.nodata_zhanwei img {
  display: block;
  width: 2.56rem;
  height: 1.72rem;
  margin: 0 auto;
  position: relative;
}

.nodata_zhanwei p {
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 0.26rem;
  color: #999999;
  margin: 0.4rem auto 0;
}

.hasData {
  width: 100%;
  position: relative;
}

.hasData_content {
  width: 100%;
  position: relative;
  background-color: #fff;
}

.hasData_content .li {
  width: calc(100% - 0.36rem);
  margin-left: 0.36rem;
  border-bottom: 0.02rem solid #f0f0f0;
  display: flex;
}

.hasData_content .li .ptext {
  display: block;
  width: 5.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.28rem;
  color: #333333;
  height: 0.8rem;
  line-height: 0.8rem;
}

.hasData_content .li .limore {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  margin-top: 0.24rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
}

.hasData_content .li .limore img {
  display: block;
  width: 100%;
}

.hasData_content .li .shoucang2,
.hasData_content .li .shoucang1 {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  margin-top: 0.24rem;
}

.hc_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  border-top: 0.02rem solid #f0f0f0;
  z-index: 9;
}

.footerDiv {
  display: block;
  width: 50%;
  height: 1rem;
  position: relative;
}

.footerDiv .btna2 {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.my_info_div img {
  display: block;
  width: 0.44rem;
  height: 0.44rem;
  margin: 0 auto 0.05rem;
}

.my_info_div span {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 0.21rem;
  color: #7e8693;
}

.activefooter span {
  color: #275caa;
}

.search_height,
.dataInfo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
}

.heightContent {
  display: block;
  width: 6.3rem;
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin-left: 1.2rem;
  position: relative;
}

.closeSearch {
  display: block;
  width: 0.58rem;
  height: 0.58rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.31rem;
}

.closeSearch img {
  display: block;
  width: 100%;
}

.heightContent_mode1 {
  width: calc(100% - 0.48rem);
  margin: 0 auto;
}

.heightContent_mode1 .songtime {
  color: #333;
  font-size: 0.29rem;
  padding: 0.3rem 0;
}

.heightContent_mode1 .time2 {
  display: flex;
  width: 100%;
  position: relative;
  justify-content: center;
}

.heightContent_mode1 .time2 .date2 {
  display: block;
  width: 2.58rem;
  height: 0.83rem;
  line-height: 0.83rem;
  font-size: 0.24rem;
  color: #333;
  background: #f3f4f8;
  border-radius: 0.45rem;
  text-align: center;
}
.line2 {
  display: block;
  width: 0.25rem;
  height: 0.03rem;
  background-color: #666;
  margin: 0.36rem 0.2rem;
}

.height_div {
  width: 100%;
  display: flex;
  position: relative;
  padding: 0 0.12rem;
  background-color: #f3f4f8;
  height: 0.83rem;
  border-radius: 0.45rem;
  margin-top: 0.4rem;
}

.height_div span {
  display: block;
  width: 1.8rem;
  color: #333333;
  font-size: 0.28rem;
  text-align: center;
  line-height: 0.83rem;
}

.height_div .input_search2 {
  display: block;
  width: calc(100% - 2rem);
  margin-left: 0.2rem;
  height: 0.83rem;
  color: #333;
}

.height_div .input_search2::-webkit-input-placeholder {
  color: #a6aeb8;
  font-size: 0.28rem;
}

.heightContent_btns {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 6.3rem;
  display: flex;
  height: 1.04rem;
  border-top: 0.02rem solid #f0f0f0;
}

.clearData {
  display: block;
  height: 1.04rem;
  line-height: 1.04rem;
  color: #666666;
  font-size: 0.29rem;
  background-color: #fff;
  text-align: center;
  width: 50%;
}

.yesSearch {
  display: block;
  height: 1.04rem;
  line-height: 1.04rem;
  color: #fff;
  font-size: 0.29rem;
  background-color: #275caa;
  text-align: center;
  width: 50%;
}

.dataInfo_content {
  position: absolute;
  background-color: #f8f8f8;
  width: 100%;
  min-height: 6vh;
  border-radius: 0.2rem 0.2rem 0 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

.dataInfo_contentTitle {
  width: 100%;
  background-color: #fff;
  padding: 0.3rem 0.32rem;
  position: relative;
}

.close_datainfo {
  display: block;
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  right: 0.32rem;
  top: 50%;
  transform: translateY(-65%);
}

.close_datainfo img {
  display: block;
  width: 100%;
}

.dataInfo_content .p1 {
  color: #3c485b;
  font-size: 0.34rem;
  margin-bottom: 0.06rem;
}

.dataInfo_content .p2 {
  color: #275caa;
  font-size: 0.24rem;
}
.dataInfo_content .pTime {
  color: #275caa;
  font-size: 0.24rem;
  padding: 0.03rem 0;
}
.dataInfo_content .pTime a {
  text-decoration: underline;
}
.info_div {
  width: calc(100% - 0.64rem);
  margin: 0 auto;
  border-bottom: 0.02rem dotted #999;
  display: flex;
  padding: 0.25rem 0;
}

.info_div span {
  color: #333333;
  font-size: 0.26rem;
  display: block;
  width: 1.8rem;
  margin-right: 0.2rem;
}

.info_div label {
  color: #333333;
  font-size: 0.26rem;
  width: calc(100% - 2rem);
}

.btnss_2 {
  position: fixed;
  width: 100%;
  height: 1.24rem;
  background-color: #fff;
  border-top: 0.02rem solid #f0f0f0;
  display: flex;
  justify-content: center;
  bottom: 0;
}

.btnss_2 div {
  display: block;
  width: 92%;
  text-align: center;
  height: 0.84rem;
  line-height: 0.84rem;
  border-radius: 0.42rem;
  margin-top: 0.2rem;
}

.btnss_2 div.btn1 {
  color: #fff;
  background-color: #048599;
  font-size: 0.28rem;
}

.btnss_2 div.btn2 {
  color: #fff;
  background-color: #275caa;
  font-size: 0.28rem;
}

.overdata {
  text-align: center;
  font-size: 0.22rem;
  color: #999;
  padding: 0.3rem 0 0.2rem;
}
</style>
